// extracted by mini-css-extract-plugin
export var highlightFade = "_25-4";
export var highlighted = "_25-3";
export var table = "_25-1";
export var tableContainer = "_25-0";
export var totalsRow = "_25-2";